var VigoShop = {
    init : function() {
       this.initFlexsliders();
        jQuery('.presentation-boxes figcaption .content').each(VigoShop.centerBox);
        jQuery('input, textarea').placeholder();
        jQuery(".main-nav").tinyNav({
            active: 'active',
            header: 'Navigation'
        });
        jQuery('.l_tinynav1').addClass('hidden-xs');
        jQuery('#tinynav1').addClass('visible-xs');
        jQuery('.scroll-top').on('click', VigoShop.scrollTop);

    },
    scrollTop : function() {
      jQuery('body, html').animate({
          scrollTop : 0
      }, 500);
    },
    textareaPlacehodler : function() {
      jQuery(this).on('keyup', function() {
         if(jQuery(this).val()) {
             jQuery(this).addClass('active');
         } else {
             jQuery(this).removeClass('active');
         }
      });
    },
   
    initFlexsliders : function() {
        jQuery('#mycarousel').jcarousel({
            vertical: true, //orientation of the carousel, in this case we use vertical
            scroll: 1, //the number of items to scroll by
            auto: 2, //the interval of scrolling
            wrap: 'last', //wrap at last item and jump back to the start
            buttonNextHTML: "<div><i class='glyphicon glyphicon-chevron-down'></i></div>",
            buttonPrevHTML: "<div><i class='glyphicon glyphicon-chevron-up'></i></div>",
            initCallback : function() {
                jQuery('#mycarousel a').on('click', function() {
                    var imgLink = jQuery(this).attr('rel');
                    jQuery('.product-image-big').fadeOut('fast', function() {
                        jQuery('.product-image-big').css({
                            "background-image" : "url('"+imgLink+"')"
                        }).fadeIn('fast');
                    });
                    return false;
                });
            }
        });

        jQuery('.latest-post-slider').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });
        VigoShop.createSliderButton('.latest-post-slider', '.latest-post-controls .next', 'next');
        VigoShop.createSliderButton('.latest-post-slider', '.latest-post-controls .prev', 'prev');

        jQuery('.footer-most-favorite').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false,
          	minItems: 1,
    		maxItems: 4
        });
        VigoShop.createSliderButton('.footer-most-favorite', '.most-favorite-controls .next', 'next');
        VigoShop.createSliderButton('.footer-most-favorite', '.most-favorite-controls .prev', 'prev');

        jQuery('.featured-slider').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });
        VigoShop.createSliderButton('.featured-slider', '.featured-slider-controls .next', 'next');
        VigoShop.createSliderButton('.featured-slider', '.featured-slider-controls .prev', 'prev');

        jQuery('.comments-slider').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });
        VigoShop.createSliderButton('.comments-slider', '.latest-comments-controls .next', 'next');
        VigoShop.createSliderButton('.comments-slider', '.latest-comments-controls .prev', 'prev');

        jQuery('.related-posts-slider').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });

        VigoShop.createSliderButton('.related-posts-slider', '.related-post-controls .next', 'next');
        VigoShop.createSliderButton('.related-posts-slider', '.related-post-controls .prev', 'prev');

        jQuery('.photo-gallery').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });

        VigoShop.createSliderButton('.photo-gallery', '.photo-gallery .next', 'next');
        VigoShop.createSliderButton('.photo-gallery', '.photo-gallery .prev', 'prev');

        jQuery('.sliderTypeOne').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false,          
        });

        VigoShop.createSliderButton('.sliderTypeOne', '.sliderTypeOne-controls .next', 'next');
        VigoShop.createSliderButton('.sliderTypeOne', '.sliderTypeOne-controls .prev', 'prev');

        jQuery('.sliderTypeTwo').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });

        VigoShop.createSliderButton('.sliderTypeTwo', '.sliderTypeTwo-controls .next', 'next');
        VigoShop.createSliderButton('.sliderTypeTwo', '.sliderTypeTwo-controls .prev', 'prev');

        jQuery('.promo-slider').flexslider({
            'controlNav': true,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });

        
      jQuery('.article-slider').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false            
        });

        VigoShop.createSliderButton('.article-slider', '.article-slider-controls .next', 'next');
        VigoShop.createSliderButton('.article-slider', '.article-slider-controls .prev', 'prev');

        jQuery('.testimonials-slider').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });

        VigoShop.createSliderButton('.testimonials-slider', '.testimonials-slider-controls .next', 'next');
        VigoShop.createSliderButton('.testimonials-slider', '.testimonials-slider-controls .prev', 'prev');

        jQuery('.logo-slider').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });
      
       
        VigoShop.createSliderButton('.logo-slider', '.logo-slider-controls .next', 'next');
        VigoShop.createSliderButton('.logo-slider', '.logo-slider-controls .prev', 'prev');

        jQuery('.team-slider').flexslider({
            'controlNav': false,
            'directionNav' : false,
            "touch": true,
            "animation": "slide",
            "animationLoop": true,
            "slideshow" : false
        });
      
      
       jQuery('#sort-by-brand, #sort-by-type, #show-no').change(function(){
        if (jQuery(this).val().length > 0) {
            window.location = jQuery(this).val();
          }
        });
      
     // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
      
    jQuery.cleared=function(A){
    if(jQuery(A).length){
    jQuery(A).each(function(){
    var B=jQuery(this).val();
    jQuery(this).focus(function(){
    if(jQuery(this).val()==B){
    jQuery(this).val("")
    }});
    jQuery(this).blur(function(){

    if(jQuery(this).val()==""){
    jQuery(this).val(B)
    }
    })
    })}};
    jQuery(document).ready(function(){
    jQuery.cleared(".textbox");
    });
      
      
      
        VigoShop.createSliderButton('.team-slider', '.team-slider-controls .next', 'next');
        VigoShop.createSliderButton('.team-slider', '.team-slider-controls .prev', 'prev');
    },
    createSliderButton : function(slider, button, action) {
        jQuery(button).click(function() {
           jQuery(slider).flexslider(action);
        });
    }
};

$(document).ready(function() {
    VigoShop.init();
});
